import React from 'react';
import CheckboxSelector from '~/components/CheckboxSelector';
import { useBookableResourcesQuery } from '~/lib/Queries';
import { ObjectTypes } from '~/lib/ObjectTypes.js';
import CustomTags from '~/components/customfields/CustomTags.jsx';

const CompactBookableResourcesSelect = ({
    className,
    label,
    value,
    onChange,
    hideIfOneType,
    dontDefaultAll,
    initialOpen,
    id,
}) => {
    const { data, isLoading } = useBookableResourcesQuery();
    const bookableResources = data || [];
    const bookableResourceOptions = bookableResources.map(br => ({
        value: br.id,
        label: br.name,
        custom_fields: br.custom_fields,
    }));

    if (
        hideIfOneType &&
        bookableResources.length <= 1 &&
        (!value || value.length === 0)
    ) {
        return null;
    }

    return (
        <div className={className}>
            {!!label && <div className="input-label">{label}</div>}
            <CheckboxSelector
                onChange={onChange}
                allValues={bookableResourceOptions}
                selectedValues={value}
                defaultAll={!dontDefaultAll}
                itemNamePlural={'people'}
                initialOpen={initialOpen}
                id={id}
                renderLabel={({ opt }) => (
                    <div>
                        {opt.label}
                        <CustomTags
                            type={ObjectTypes.BOOKABLE_RESOURCE}
                            id={opt.value}
                            fields={opt.custom_fields}
                        />
                    </div>
                )}
            />
        </div>
    );
};

export default CompactBookableResourcesSelect;
